module.exports = __webpack_public_path__ + "static/hip-flash-new-3-9d83aea8f1dfef4dc6ed79db0de4d6ff.jpg";